import React from 'react';
import PropTypes from 'prop-types';
import { KPI_GREEN, KPI_RED } from '../../../core/chart/colors';
import Table from '../../../core/form/Table';
import Icon from '../../../core/layout/Icon';
import PlacementTestReportTestDialogAnsweredQuestionListItem from './PlacementTestReportTestDialogAnsweredQuestionListItem';

export default function PlacementTestReportTestDialogAnsweredQuestionList(props) {
  return (
    <Table
      fetching={false}
      expandableComponent={(row) => <PlacementTestReportTestDialogAnsweredQuestionListItem data={row} />}
      columns={[
        {
          label: 'Level',
          path: 'grammarPlacementTestLevel.placementTestLevel.course.name',
        },
        {
          label: 'Status',
          path: 'correct',
          render: (correct) => (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Icon name={correct ? 'check' : 'close'} style={{ color: correct ? KPI_GREEN : KPI_RED }} />
            </div>
          ),
        },
        {
          label: 'Grammar',
          path: 'item.grammar.name',
        },
        {
          label: 'Skill',
          path: 'item.type.key',
          render: (value) => {
            if (value === 'SINGLE_CHOICE_TEXT') {
              return 'R/L';
            }
            if (
              ['GAP_FILL', 'GAP_FILL_MULTIPLE', 'GAP_FILL_SELECT', 'UNSCRAMBLE_DRAG_AND_DROP'].some(
                (type) => type === value
              )
            ) {
              return 'R';
            }
            if (['SINGLE_CHOICE_AUDIO', 'SINGLE_CHOICE_IMAGE'].some((type) => type === value)) {
              return 'L';
            }
          },
        },
      ]}
      rows={props.data}
    />
  );
}

PlacementTestReportTestDialogAnsweredQuestionList.propTypes = {
  data: PropTypes.array,
};

PlacementTestReportTestDialogAnsweredQuestionList.defaultProps = {
  data: [],
};
